module.exports = __webpack_public_path__ + "static/img/success.cd3711a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/success.png
// module id = mzrL
// module chunks = 1